import { defaultMonarchResponse } from '@hen-site/constants/monarch';
import type {
  MonarchBase,
  MonarchResponse,
  PersonalizedAssetType,
} from '@hen-site/types/monarch';
import { useMonarchRequest } from '@redventures/cohesion-utils-react';

/**
 * Fetches Monarch global ruleset via Cohesion (ruleset, globalRuleSet).
 * Used by MonarchProviderWrapper to supply monarchBase to GlobalContextProvider.
 */
const useMonarchData = (): MonarchBase => {
  const { isLoading: isMonarchLoading, value } =
    useMonarchRequest<MonarchResponse>('ruleset', 'globalRuleSet', {
      default: defaultMonarchResponse,
      payload: {},
      skip: false,
    });

  let assetType: PersonalizedAssetType | undefined;
  let assetData: Record<string, unknown> | undefined;

  if (value?.joQDF?.data) {
    assetType = value.joQDF.data.PersonalizedAssetType;
    assetData = value.joQDF.data.PersonalizedAssetData;
  } else {
    assetType = value?.joQDF?.PersonalizedAssetType;
    assetData = value?.joQDF?.PersonalizedAssetData as
      | Record<string, unknown>
      | undefined;
  }

  return {
    ...(value || defaultMonarchResponse),
    isMonarchLoading,
    joQDF: {
      data: {
        PersonalizedAssetType: (assetType ??
          'default') as PersonalizedAssetType,
        PersonalizedAssetData: assetData ?? {},
      },
    },
    editorialListing: value?.editorialListing
      ? value.editorialListing
      : undefined,
  };
};

export default useMonarchData;
